module.exports = __webpack_public_path__ + "img/initial-zhant.e15ff73f.png";